module.exports = __webpack_public_path__ + "img/bgImg2.2ccead03.jpg";